const EmptySearchContent = ({ locale, push }) => {
  return (
    <div className="min-h-[70vh] items-center flex flex-col justify-center">
      <h3 className="mx-auto text-[1.5rem] font-[600]">
        {locale === "ar" ? "عفوًا، لا توجد نتائج بحث!" : "No Search Results!!"}
      </h3>
      <button
        onClick={() => push("/")}
        className="mt-[1rem] text-[1.2rem] min-w-[280px] min-h-[60px] text-white font-[600] bg-[#D9232E] rounded-[4px] border-[1px] border-[#D9232E] hover:bg-white hover:text-[#D9232E] duration-150 flex justify-center items-center"
      >
        {locale === "ar" ? "متابعة التسوق" : "Continue shopping"}
      </button>
    </div>
  );
};

export default EmptySearchContent;
